export default function getExtraParams(
  extraParams: string[] | undefined,
  params: Record<string, any>,
) {
  if (!extraParams) return {};

  const keys = Array.isArray(extraParams) ? extraParams : [extraParams];

  return keys.reduce(
    (acc, key) => {
      if (key in params) acc[key] = params[key];
      return acc;
    },
    {} as Record<string, any>,
  );
}
